import React, {useContext} from 'react';
import {OrderViewContext} from "./OrderViewContext";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {exportXLSXFile} from "../../utils/exportCSVFile";

function TableButtons(props) {

  const helper = useContext(OrderViewContext);
  const setData = helper.setData
  const data = helper.data
  const appliedFilter = helper.appliedFilter;
  const isLoading = helper.isLoading;
  const isCurrentResult = appliedFilter === JSON.stringify(data.filter);

  const navigateTo = useNavigate()
  console.log(data)

  const handleExport = () => {
    // The API response already includes the selected date and payment filters.
    // Export its full result instead of currentTableData, which is only the
    // visible pagination page.
    const filteredOrders = data?.tableData?.data;
    if (isCurrentResult && !isLoading && Array.isArray(filteredOrders) && filteredOrders.length > 0 && data?.tableData?.columns) {
      const headers = {};
      data.tableData.columns.forEach(col => {
        if (col.field && col.title) {
          headers[col.field] = col.title;
        }
      });

      const dateRange = [data.filter?.startDate, data.filter?.endDate]
        .filter(Boolean)
        .join("_")
        .replaceAll("/", "-");
      const fileName = dateRange ? `OrderList_${dateRange}` : "OrderList";
      exportXLSXFile(filteredOrders, fileName, headers);
    } else {
      toast.error("داده‌ای برای خروجی وجود ندارد");
    }
  }

  return (<div>

    <div className={"d-flex"}>

      <button
        className={"theme1__btn theme1__btn__main"}
        onClick={() => {
          navigateTo('/OrdersSadan')
        }}
      >
        افزودن سفارش
      </button>
      <button
        className={"theme1__btn mx-2"}
        onClick={handleExport}
        disabled={isLoading || !isCurrentResult}
      >
        خروجی اکسل
      </button>
      {/*<button*/}
      {/*  className={"theme1__btn"}*/}
      {/*  onClick={() => {*/}


      {/*    if (data?.selectedRowId) {*/}
      {/*      navigateTo('/OrdersSadan',{state: {id: data?.selectedRowId}})*/}
      {/*    } else {*/}
      {/*    toast('برای ویرایش باید یک سطر را انتخاب کنید.')*/}

      {/*    }*/}
      {/*  }}*/}
      {/*>*/}
      {/*  ویرایش سفارش*/}
      {/*</button>*/}
    </div>

  </div>);
}

export default TableButtons;
